// cspell:ignore initialised
// terra-react and the native Terra SDK keep a single global TerraManager instance:
// every initTerra call replaces it, and the SDK hands the *newest* instance to
// whichever initTerra callback fires next — even an instance that is still
// initializing or whose initialization silently failed. Two overlapping
// initTerra → initConnection flows therefore poison each other, and initConnection
// fails with "Please make sure the Terra class is initialised properly".
// Every flow that creates a Terra instance (initTerra) and then relies on it must
// run through this lock so only one such flow is active at a time.
let terraOperationQueue: Promise<unknown> = Promise.resolve()

export const withTerraLock = <T>(operation: () => Promise<T>): Promise<T> => {
  const run = terraOperationQueue.then(operation)
  terraOperationQueue = run.catch(() => undefined)
  return run
}
